/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Playground_TitleInputs */

const vi_dev_playground_title = /** @type {(inputs: Dev_Playground_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khu thử nghiệm (đang phát triển)`)
};

/**

* @param {Dev_Playground_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dev_playground_title = /** @type {((inputs?: Dev_Playground_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Playground_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dev_playground_title(inputs)
});